// MDM GraphQL Mutations
// All GraphQL mutations related to mobile device management
import { gql } from '@apollo/client';

// Add Policies Mutation
const ADD_POLICIES = gql`
  mutation addPolicies(
    $policySetId: ID!
    $policyType: String
    $policyInput: [PolicyInput!]
    $clientId: ID
    $siteId: ID
    $assetId: ID
  ) {
    addPolicies(
      policySetId: $policySetId
      policyType: $policyType
      policyInput: $policyInput
      clientId: $clientId
      siteId: $siteId
      assetId: $assetId
    ) {
      policyId
      name
      description
      enabled
      policyType
      mdmRestrictions {
        attributePath
        attributeDataType
        value
      }
      mdmWifiPolicyConfig {
        configId
        ssid
        encryptionType
        wifiPassword
        autoJoin
        disableRandomMacAddress
        enableIPv6
        hidden
        hotspot
        wifiProxyType
        proxyPACFallbackAllowed
        proxyPACURL
        proxyServerHost
        proxyServerPort
        proxyUserName
        proxyPassword
      }
      mdmProxyPolicyConfig {
        configId
        proxyType
        host
        port
        userName
        password
        pacURL
        pacFallbackAllowed
        proxyCaptiveLoginAllowed
      }
      mdmAndroidOSUpdatePolicyConfig {
        configId
        updateType
        updateWindow {
          startTime
          endTime
        }
      }
      osUpdateSettings {
        notifications
        rapidSecurityResponse {
          enable
          enableRollback
        }
        automaticActions {
          download
          installOSUpdates
        }
        deferrals {
          combinedPeriodInDays
        }
        recommendedCadence
      }
      osUpdateEnforcement {
        enforcementType
        majorOsUpdateEnforcement {
          afterDays
          time
        }
        minorOsUpdateEnforcement {
          afterDays
          time
        }
        osUpdateVersionEnforcements {
          versionEnforcementId
          targetVersion
          targetLocalDateTime
        }
      }
    }
  }
`;

// Update Policies Mutation
const UPDATE_POLICIES = gql`
  mutation updatePolicies($policySetId: ID!, $policyInput: [PolicyInput!]) {
    updatePolicies(policySetId: $policySetId, policyInput: $policyInput) {
      policyId
      name
      description
      enabled
      policyType
      mdmRestrictions {
        attributePath
        attributeDataType
        value
      }
      mdmWifiPolicyConfig {
        configId
        ssid
        encryptionType
        wifiPassword
        autoJoin
        disableRandomMacAddress
        enableIPv6
        hidden
        hotspot
        wifiProxyType
        proxyPACFallbackAllowed
        proxyPACURL
        proxyServerHost
        proxyServerPort
        proxyUserName
        proxyPassword
      }
      mdmProxyPolicyConfig {
        configId
        proxyType
        host
        port
        userName
        password
        pacURL
        pacFallbackAllowed
        proxyCaptiveLoginAllowed
      }
      mdmAndroidOSUpdatePolicyConfig {
        configId
        updateType
        updateWindow {
          startTime
          endTime
        }
      }
      osUpdateSettings {
        notifications
        rapidSecurityResponse {
          enable
          enableRollback
        }
        automaticActions {
          download
          installOSUpdates
        }
        deferrals {
          combinedPeriodInDays
        }
        recommendedCadence
      }
      osUpdateEnforcement {
        enforcementType
        majorOsUpdateEnforcement {
          afterDays
          time
        }
        minorOsUpdateEnforcement {
          afterDays
          time
        }
        osUpdateVersionEnforcements {
          versionEnforcementId
          targetVersion
          targetLocalDateTime
        }
      }
      thirdPartyApplicationConfig {
        scheduleDetail
        bundleConfigs {
          bundle {
            id
            name
          }
          applicationConfigs {
            application {
              name
              id
              applicationReferenceId
              iconUrl
              title
              author
              patchOptions
              thirdPartyPackageManager {
                pmId
                packageManager
              }
              packageType
              status
            }
            patchType
          }
        }
        applicationConfigs {
          application {
            id
            name
            applicationReferenceId
            title
            author
            iconUrl
            applicationUrl
            patchOptions
            packageType
            status
            thirdPartyPackageManager {
              pmId
              packageManager
            }
            additionalIdentifier
          }
          patchType
        }
      }
      mdmAppleSoftwareConfig {
        installIfVPPLicenseExpired
        installWithoutVPP
      }
    }
  }
`;

const DELETE_MDM_CONFIGURATIONS = gql`
  mutation deleteMDMConfigurations {
    deleteMDMConfigurations
  }
`;

export { ADD_POLICIES, UPDATE_POLICIES, DELETE_MDM_CONFIGURATIONS };
